import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { Role } from "@siteimprove/alfa-aria";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Criterion, Technique } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { roleAttributes } from "../common/applicability/role-attributes.js";
import { Scope, Stability } from "../tags/index.js";
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r110",
    requirements: [
        Criterion.of("1.3.1"),
        Technique.of("ARIA4"),
        Technique.of("G108"),
    ],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return roleAttributes(document, device);
            },
            expectations(target) {
                return {
                    1: expectation(target
                        .tokens()
                        .some((token) => Role.isName(token) && Role.of(token).isConcrete()), () => Outcomes.HasValidRole, () => Outcomes.HasNoValidRole),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasValidRole = Ok.of(Diagnostic.of(`The element has a at least one valid role`));
    Outcomes.HasNoValidRole = Err.of(Diagnostic.of(`The element does not have a valid role`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map